<template>
  <div class="product" @click="onDetail">
    <el-image class="product-image" :src="product.image_show" />
    <div class="product-content">
      <div class="title">{{product.title}}</div>
      <div class="desc">{{ product.content }}</div>
      <div class="price">¥{{ product.price_min }} - ¥{{ product.price_max }}</div>
      <div class="foot">
          <div class="product-id">ID:{{product.id}}</div>
          <div class="product-id">
            <img class="product-id-image" src="@/assets/images/icons/click.png" />
            <span class="product-id-text">{{product.click}}</span>
          </div>
          <div class="product-id">
            <img class="product-id-image" src="@/assets/images/icons/time.png" />
            <span class="product-id-text">{{ formatStr2Date(product.update_time) }}</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatDate} from '@/utils/util'
export default {
  name: 'Product',
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    formatStr2Date(str) {
      return formatDate(str)
    },
    onDetail() {
      this.$router.push({name: 'detail', query: {id: this.product.id}})
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  margin-top: 20px;

  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: dashed #e5e5e5 1px;
  cursor: pointer;
  .product-image {
    width: 100px;
    height: 100px;
  }
  .product-content {
    padding-left: 15px;
    // width: 755px;
    height: 100px;
    flex: 1;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    .desc {
      height: 40px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; //行数
      overflow: hidden; 
      font-size: 14px;
      color: grey;
    }
    .price {
      color: $red;
    }
    .foot {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: $grey;
      font-size: 14px;
      .product-id {
        display: flex;
        flex-direction: row;
        align-items: center;
        .product-id-image {
          width: 16px;
          height: 16px;
        }
        .product-id-text {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>